import React from "react";
import Rightside from "./components/right";
import Sidebar from "./components/sidebar";

function Listing() {
    return (
      <div>
          <div className="listing_section top_space">
               <div className="container">
                    <div className="row">
                          <div className="col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12">
                              <div className="listing_area_wrap">
                                  <Sidebar />
                                  <Rightside />
                              </div>
                          </div>
                    </div>
               </div>
          </div>
      </div>
    );
}

export default Listing;
